module.exports = __webpack_public_path__ + "static/media/humidity.5a8a7ff5.svg";